import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const MILEAGE = `/mileage-tracker`;


export const getMileageList = createAsyncThunk(
  "getMileageList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, search = "", main_category = "", status = "", property = "", owner_uuid = "", recurring_filter = "" } = values;
      const response = await http.get(`${MILEAGE}?page=${page}&limit=${limit}&search=${search}&main_category=${main_category}&status=${status}&property=${property}&owner_uuid=${owner_uuid}&recurring_filter=${recurring_filter}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getMileageDetails = createAsyncThunk(
  "getMileageDetails",
  async ({ uuid }: { uuid: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${MILEAGE}/${uuid}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to get mileage details");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateMileage = createAsyncThunk(
  "updateMileage",
  async ({ uuid, values }: { uuid: any, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${MILEAGE}/${uuid}`, values);
      toast.success(response?.data?.message || "Mileage updated Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update mileage");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addMileage = createAsyncThunk(
  "addMileage",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${MILEAGE}`, values);
      toast.success(response?.data?.message || "Mileage added Successfully.");
      dispatch(getMileageList({}));
      return response?.data;
    }
    catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to add mileage");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteMileage = createAsyncThunk(
  "deleteMileage",
  async ({ uuid }: { uuid: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.delete(`${MILEAGE}/${uuid}`);
      toast.success(response?.data?.message || "Mileage deleted Successfully.");
      dispatch(getMileageList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete mileage");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteMileageReceipt = createAsyncThunk(
  "deleteMileageReceipt",
  async ({ uuid, mileageId }: { uuid: string, mileageId: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.delete(`${MILEAGE}/${mileageId}/image/${uuid}`);
      console.log('response ========= ', response);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete user");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);
